module.exports = __webpack_public_path__ + "static/media/saikrishna.385675e9.png";